import { TypedDocumentNode, gql } from "@apollo/client";

type ConstantValue = {
  id: string;
  name: string;
};

export const GET_CONSTANT_VALUE_LIST: TypedDocumentNode<{
  constantValueByConstant: ConstantValue[];
}> = gql`
  query GetConstantValueList($constantType: String!) {
    constantValueByConstant(constant: $constantType) {
      id
      name
    }
  }
`;
